import * as Types from '../types';
import { Environment } from '../../../config';
import request from '../../../utils/request';

export interface IDataItem {
  vat_rate_id: number;
  country_id: number;
  country_code: string;
  country_name: string;
  vat_rate_type_id: number;
  vat_rate_type: string;
  vat_rate: number;
  valid_from: string;
  valid_to: string | null;
}

export interface IVatRateType {
  vat_rate_type_id: number;
  description: string;
}

export interface IPaging {
  page: number;
  pageSize: number;
  total: number;
}

export interface IVatRateListOutput {
  items: IDataItem[];
  paging: IPaging;
}

export interface IVatRateListInput {
  sortField: string;
  page: number;
  pageSize: number;
  order: 'asc' | 'desc';
  country_code?: string;
  vat_rate_type_id?: string;
  valid_from?: string;
  valid_to?: string;
}

export interface IUpdateVatRateInput {
  vat_rate_id: number;
  vat_rate_type_id: number;
  vat_rate: number;
  valid_from: string;
  valid_to: string | null;
}

export interface IAddVatRateInput {
  country_id: number;
  vat_rate_type_id: number;
  vat_rate: number;
  valid_from: string;
  valid_to: string | null;
}

export const fetchVatRateTypes = async (): Promise<Types.ResponseOutput> => {
  const { data }: any = await request(
    'get',
    `${Environment.API_BASE_URL}/api/vat-rate/types`
  );
  let output: Types.ResponseOutput = {
    message: data.message,
    data: data.data as IVatRateType[],
    status: data.status,
  };
  return output;
};

export const addVatRate = async (
  payload: IAddVatRateInput
): Promise<Types.ResponseOutput> => {
  const { data }: any = await request(
    'post',
    `${Environment.API_BASE_URL}/api/vat-rate`,
    {
      country_id: payload.country_id,
      vat_rate_type_id: payload.vat_rate_type_id,
      vat_rate: payload.vat_rate,
      valid_from: payload.valid_from,
      valid_to: payload.valid_to,
    }
  );
  let output: Types.ResponseOutput = {
    message: data.message,
    data: data.data,
    status: data.status,
  };
  return output;
};

export const updateVatRate = async (
  payload: IUpdateVatRateInput
): Promise<Types.ResponseOutput> => {
  const { data }: any = await request(
    'patch',
    `${Environment.API_BASE_URL}/api/vat-rate/${payload.vat_rate_id}`,
    {
      vat_rate_type_id: payload.vat_rate_type_id,
      vat_rate: payload.vat_rate,
      valid_from: payload.valid_from,
      valid_to: payload.valid_to,
    }
  );
  let output: Types.ResponseOutput = {
    message: data.message,
    data: data.data,
    status: data.status,
  };
  return output;
};

export const fetchVatRateList = async (
  payload: IVatRateListInput
): Promise<Types.ResponseOutput> => {
  const queryParams = new URLSearchParams({
    page: payload.page.toString(),
    pageSize: payload.pageSize.toString(),
    sortField: payload.sortField,
    order: payload.order,
    ...(payload.country_code && { country_code: payload.country_code }),
    ...(payload.vat_rate_type_id && { vat_rate_type_id: payload.vat_rate_type_id }),
    ...(payload.valid_from && { valid_from: payload.valid_from }),
    ...(payload.valid_to && { valid_to: payload.valid_to }),
  });
  const { data }: any = await request(
    'get',
    `${Environment.API_BASE_URL}/api/vat-rate/list?${queryParams.toString()}`
  );

  let _data: IVatRateListOutput = data.data;
  let output: Types.ResponseOutput = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};
